export default __webpack_public_path__ + "static/media/whyBrokerVTGMIcon.a150fb50.webp";